import { BasedB2CTransactionRequestModel } from "app/based/baseApiModel/baseTransactionHistory/basedB2CTransaction/BasedB2CTransactionRequestModel";

export class AirTimeRegistrationRequestEntity extends BasedB2CTransactionRequestModel {
  code?: string;
  created?: Record<string, unknown>[];
  fromDate?: string;
  limit?: number;
  page?: number;
  partner?: string;
  platform?: string;
  status?: string;
  store?: string;
  toDate?: string;
  transRef?: string;
  type?: string;
  user?: string;

  constructor(data?: Partial<AirTimeRegistrationRequestEntity>) {
    super(data);
    Object.assign(this, data);
  }
}
